"use client";
const labels = ["Tài", "Hòa", "Xỉu"];

const OverUnderOddRate = ({ homeArray, awayArray }) => {
  const totalHome = homeArray[0] || 1;
  const totalAway = awayArray[0] || 1;

  const oddsOverRate = ((Number(homeArray[5]) || 0) / totalHome * 100);
  const oddsUnderRate = ((Number(awayArray[7]) || 0) / totalAway * 100);
  const oddsVoidRate = 100 - (oddsOverRate + oddsUnderRate);

  const homeOverUnderData = [oddsOverRate.toFixed(0), oddsVoidRate.toFixed(0), oddsUnderRate.toFixed(0)];
  const awayOverUnderData = [oddsUnderRate.toFixed(0), oddsVoidRate.toFixed(0), oddsOverRate.toFixed(0)];

  return (
    <div className="px-[20px] w-full flex flex-col gap-2 items-center justify-center">
      <div
        className={
          "w-full  font-bold text-xs  flex flex-row gap-8 [&>*]:flex-1 [&>*]:text-center [&>*:first-child]:pl-[0] [&>*:last-child]:pr-[0] divide-league-dark-detail text-blur-gray"
        }
      >
        {labels.map((label, index) => (
          <div className={"flex flex-col gap-2 "}>
            <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
              <div
                className={
                  "w-[30px] h-[88px] flex flex-col justify-end bg-[#ebeff5] dark:bg-dark-slate rounded-tl rounded-tr text-button-blue-bet"
                }
              >
                <div>{homeOverUnderData[index] || ""}%</div>
                <div
                  className={"bg-button-blue-bet"}
                  style={{ height: `${homeOverUnderData[index]}%` }}
                ></div>
              </div>
              <div
                className={
                  "w-[30px]  h-[88px] flex flex-col justify-end bg-[#f6f5ef] dark:bg-dark-slate rounded-tl rounded-tr text-golden-yellow"
                }
              >
                <div>{awayOverUnderData[index] || ""}%</div>
                <div
                  className={"bg-golden-yellow"}
                  style={{ height: `${awayOverUnderData[index]}%` }}
                ></div>
              </div>
            </div>
            <div className={"w-full rounded font-semi-bold text-center"}>
              {label}
            </div>
          </div>
        ))}
      </div>

      <div className="text-blur-gray rounded-[10px] bg-white dark:bg-dark-slate dark:text-white p-2 px-5">
        Tỷ lệ tài xỉu ({homeArray[0] || 0} Trận - {awayArray[0] || 0} Trận)
      </div>
    </div>
  );
};

export default OverUnderOddRate;
